import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  STOP_COPYING_BUTTON: `${cleanedFilename(__filename)}-stop-copying-button`,
};
